import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography as MUITypography } from '@material-ui/core';
import type { TypographyProps } from '@material-ui/core/Typography';
import classnames from 'classnames';

import type { KlpStyled } from '../Theme';
import { removeKlpStyles, useKlpStyles } from '../Theme';
import type { IKlpPalette } from '../Theme/IKlpStyles';
import { KlpPalette } from '../Theme/KlpPalette';

interface IOwnProps {
    translation?: string;
    translationOptions?: object;
    background?: keyof Omit<IKlpPalette, 'background'>;
}

export type IBlockProps = IOwnProps & KlpStyled & TypographyProps;

export const Block = forwardRef<HTMLDivElement, IBlockProps>(
    (
        {
            children,
            className,
            translation,
            translationOptions,
            background,
            ...restProps
        },
        ref,
    ) => {
        const { t } = useTranslation();
        const styles = useKlpStyles(restProps);
        return (
            <MUITypography
                ref={ref}
                variant="body1"
                variantMapping={{ body1: 'div' }}
                className={classnames(styles.klpStyles, className)}
                style={{
                    backgroundColor: background && KlpPalette[background].light,
                }}
                {...removeKlpStyles(restProps)}
            >
                {translation ? t(translation, translationOptions) : children}
            </MUITypography>
        );
    },
);
Block.displayName = 'Block';
